import SumberDayaPPA from './SumberDayaPPA'

export default SumberDayaPPA